import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/info.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4b73902a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "other-amount-title" }
const _hoisted_2 = { class: "amount-to-be-paid-div" }
const _hoisted_3 = { class: "amount-to-be-paid-input-box" }
const _hoisted_4 = { for: "amount-to-be-paid-input" }
const _hoisted_5 = { class: "minimum-amount-title" }
const _hoisted_6 = { class: "other-amount-conditional-messages" }
const _hoisted_7 = {
  key: 0,
  class: "superpacman-other-amount-warning-text"
}
const _hoisted_8 = {
  key: 1,
  class: "amount-just-right-text"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "superpacman-other-amount-info-icon",
  src: _imports_0
}, null, -1))
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.t("superpacman-other-amount-title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.currency.symbol), 1),
        _withDirectives(_createElementVNode("input", {
          id: "amount-to-be-paid-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amountToBePaid) = $event)),
          placeholder: "0",
          type: "text",
          inputmode: "numeric",
          class: "amount-to-be-paid-input",
          style: _normalizeStyle(_ctx.amountInputCssVar),
          maxlength: "14",
          autocomplete: "off",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkAmountToBePaid && _ctx.checkAmountToBePaid(...args))),
          onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stripDecimalOnFocus && _ctx.stripDecimalOnFocus(...args))),
          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.formatAmountOnBlur && _ctx.formatAmountOnBlur(...args)))
        }, null, 36), [
          [_vModelText, _ctx.amountToBePaid]
        ])
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t("superpacman-minimum-amount")) + ": " + _toDisplayString(_ctx.computedAmountValue(_ctx.minimumAmount)), 1),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
          : (_ctx.nextValidThrough)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.t("superpacman-next-payment-date")) + ": " + _toDisplayString(_ctx.nextValidThrough), 1)
              ]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        id: "confirm-other-amount-button",
        disabled: !_ctx.nextValidThrough,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
      }, _toDisplayString(_ctx.t("superpacman-confirm-button")), 9, _hoisted_10)
    ])
  ], 64))
}